module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand9-cd1b5cdf5a1b192f54abf4e078e8fcf5.jpg";